interface IStepDefinitionSchema {
    type: string;
    name: string;
    icon: string;
    normalDuration: string;
    minDuration: string;
    maxDuration: string;
    stateDefinition?: string;
    zones?: string[];
    zoneType?: string;
    slug?: string;
    finishTripAfter?: string;
    isNonOperative?: boolean;
}

export interface ICheckpointDefinitionSchema {
    id?: string;
    type: string;
    stateDefinition?: string;
    transitionStateDefinition?: string;
    operationType?: string;
    steps: IStepDefinitionSchema[];
}

export interface ITripDefinitionSchema {
    id: string;
    name: string;
    locale?: string;
    tripLifetime?: string;
    tripStartedLifetime?: string;
    ttlFinishedTrips: string;
    delayedYellow: string;
    delayedRed: string;
    pendingColor: string;
    finishedColor: string;
    minPercentage?: number;
    maxPercentage?: number;
    maxDrivingTime?: number;
    restingTime?: number;
    maxDailyDrivingTime?: number;
    drivingTimeWindow?: [string, string][];
    drivingTimeWindowTolerance?: number;
    metersWithoutOptions?: number;
    finishOnLastCheckpointStep?: boolean;
    forceShowLastCheckpointNext?: boolean;
    autoGenerateTripCode?: boolean;
    startNextTripOnPrevFinish?: boolean;
    checkpointDefinitions: ICheckpointDefinitionSchema[];
}
